import { SalesforceOAuthDataSchema } from '@weft/types';
import type { oz } from '@weft/utils';

export const SalesforceConnectRequestSchema = SalesforceOAuthDataSchema.openapi('salesforceConnectRequest');

export type SalesforceConnectRequestPayload = oz.infer<typeof SalesforceConnectRequestSchema>;